// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"HLnmbN9SJ5Q1mIO8-E3gJ"};